module.exports = __webpack_public_path__ + "img/em-pros-03.19774e2b.png";